import { Component, computed, inject, signal } from '@angular/core';
import { BaseDialogComponent, DialogHeaderComponent } from '@cumlaude/shared-components-dialogs';
import { ButtonComponent } from '@cumlaude/shared-components-buttons';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

export interface DataExportFavorietOpslaanOptions {
	origineleNaam?: string;
}

@Component({
	selector: 'app-data-export-favoriet-opslaan-dialog',
	templateUrl: './data-export-favoriet-opslaan-dialog.component.html',
	styleUrls: ['./data-export-favoriet-opslaan-dialog.component.scss'],
	imports: [BaseDialogComponent, DialogHeaderComponent, ButtonComponent],
})
export class DataExportFavorietOpslaanDialogComponent {
	protected dialogRef = inject<DialogRef<string, DataExportFavorietOpslaanOptions>>(DialogRef);
	private readonly dialogData = inject<DataExportFavorietOpslaanOptions>(DIALOG_DATA);

	readonly naam = signal(this.dialogData.origineleNaam ?? '');

	readonly notEmpty = computed(() => this.naam().length > 0);

	close() {
		if (!this.notEmpty()) return;

		this.dialogRef.close(this.naam());
	}
}
